import React from 'react';
import MiniDrawer from '../components/Header';
import TeamPageContent from '../components/team/TeamPageContent';
export default function TeamPage({ token }) {
    return (React.createElement(MiniDrawer, { type: "team" },
        React.createElement(TeamPageContent, { token: token })));
}
